document.addEventListener('DOMContentLoaded', () => {
  const practiceHeader = document.querySelector('.practice-header[data-text-class]')
  if (!practiceHeader) return

  const header = document.querySelector('header:not(.sticky-header)')
  if (!header) return

  const dataset = practiceHeader.dataset
  const newTextClass = dataset.textClass || ''
  const newFillClass = (dataset.fillClass || '').replace(' path', '').replace(' polygon', '')
  const newStrokeClass = (dataset.strokeClass || '').replace(' path', '').replace(' polygon', '')
  const inverseTextClass = dataset.inverseTextClass || ''
  const inverseFillClass = (dataset.inverseFillClass || '')
    .replace(' path', '')
    .replace(' polygon', '')
  const btnBgClass = dataset.btnBgClass || ''

  // Get background class from practice header color classes
  const newBgClass = newTextClass ? newTextClass.replace('-text', '-bg') : ''

  // Helper function to remove category classes
  const removeCategoryClasses = (element, suffixes) => {
    const classesToRemove = Array.from(element.classList).filter(
      cls => cls.startsWith('category-') && suffixes.some(suffix => cls.endsWith(suffix))
    )
    element.classList.remove(...classesToRemove)
  }

  // Apply classes if they exist
  if (newTextClass) {
    const textElements = header.querySelectorAll(
      'a:not(.dropdown-content a, .btn-sm a, .btn-lg a, a:has(.btn-sm), a:has(.btn-lg), #mobile-menu-trigger a, #mobile-menu a), p:not(.dropdown-content p, .btn-sm p, .btn-lg p, #mobile-menu-trigger p, #mobile-menu p), span:not(.dropdown-content span, .dropdown-icon, .btn-sm span, .btn-lg span, #mobile-menu-trigger span, #mobile-menu span)'
    )
    textElements.forEach(element => {
      if (element.closest('.btn-sm, .btn-lg')) return
      removeCategoryClasses(element, ['-text'])
      element.classList.add(newTextClass)
    })
  }

  if (newFillClass || newStrokeClass) {
    const svgElements = header.querySelectorAll(
      'svg:not(.btn-sm svg, .btn-lg svg, #mobile-menu-trigger svg, #mobile-menu svg)'
    )
    svgElements.forEach(svg => {
      if (svg.closest('.btn-sm, .btn-lg, #mobile-menu-trigger, #mobile-menu')) return

      removeCategoryClasses(svg, ['-fill', '-fill-inverse', '-stroke'])
      if (newFillClass) svg.classList.add(newFillClass)
      if (newStrokeClass) svg.classList.add(newStrokeClass)

      const elementsToUpdate = svg.querySelectorAll('path, polygon, rect, circle, line, polyline')
      elementsToUpdate.forEach(element => {
        removeCategoryClasses(element, ['-fill', '-stroke'])
        if (newFillClass) element.classList.add(newFillClass)
        if (newStrokeClass) element.classList.add(newStrokeClass)
      })
    })
  }

  // Update mobile menu trigger SVG (hamburger icon)
  if (newFillClass || newStrokeClass) {
    const mobileMenuTrigger = header.querySelector('#mobile-menu-trigger svg')
    if (mobileMenuTrigger) {
      // Remove all category fill classes from SVG
      removeCategoryClasses(mobileMenuTrigger, ['-fill', '-fill-inverse', '-stroke'])

      // Add the new fill and stroke classes to SVG
      if (newFillClass) mobileMenuTrigger.classList.add(newFillClass)
      if (newStrokeClass) mobileMenuTrigger.classList.add(newStrokeClass)

      // Update all SVG elements that need color changes
      const triggerElementsToUpdate = mobileMenuTrigger.querySelectorAll(
        'path, polygon, rect, circle, line, polyline'
      )
      triggerElementsToUpdate.forEach(element => {
        // Remove all category fill classes
        removeCategoryClasses(element, ['-fill', '-stroke'])

        // Add the new fill and stroke classes
        if (newFillClass) element.classList.add(newFillClass)
        if (newStrokeClass) element.classList.add(newStrokeClass)
      })
    }
  }

  // Dropdown content colors are preserved from CSS - no changes needed

  // Mobile menu colors are preserved from CSS - no changes needed

  // Mobile menu buttons and search form colors are preserved from CSS - no changes needed

  // Update desktop search form only
  if (newTextClass) {
    const desktopSearchForm = header.querySelector('header-search')
    if (desktopSearchForm) {
      removeCategoryClasses(desktopSearchForm, ['-text'])
      desktopSearchForm.classList.add(newTextClass)
    }
  }

  if (btnBgClass && inverseTextClass && inverseFillClass) {
    const buttons = header.querySelectorAll('.btn-sm:not([type="submit"]), .btn-lg:not([type="submit"])')
    buttons.forEach(button => {
      removeCategoryClasses(button, [
        '-text',
        '-inverse-text',
        '-fill',
        '-fill-inverse',
        '-bg',
        '-btn-bg',
        '-btn-bg-inverse',
      ])

      button.classList.add(btnBgClass)
      button.classList.add(inverseTextClass) // Apply inverse text color

      const buttonSvgs = button.querySelectorAll('svg')
      buttonSvgs.forEach(svg => {
        removeCategoryClasses(svg, ['-fill', '-fill-inverse'])
        svg.classList.add(inverseFillClass) // Apply inverse fill color
      })
    })
  }
})
